function addThousandsSeparators(value) {
  return value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function formatTokenBalance(amountAtomic, decimals) {
  const normalizedAmount = String(amountAtomic ?? '0').trim();
  const normalizedDecimals = Number.parseInt(decimals ?? 0, 10);

  if (!/^\d+$/.test(normalizedAmount)) {
    return '0';
  }

  if (!Number.isFinite(normalizedDecimals) || normalizedDecimals <= 0) {
    return addThousandsSeparators(normalizedAmount);
  }

  const wholePart =
    normalizedAmount.length > normalizedDecimals
      ? normalizedAmount.slice(0, -normalizedDecimals)
      : '0';
  const fractionalPart = normalizedAmount.slice(-normalizedDecimals).padStart(normalizedDecimals, '0');
  const trimmedFractionalPart = fractionalPart.replace(/0+$/, '');
  const formattedWholePart = addThousandsSeparators(wholePart);

  if (!trimmedFractionalPart) {
    return formattedWholePart;
  }

  return `${formattedWholePart}.${trimmedFractionalPart}`;
}